import { render, staticRenderFns } from "./IntervalNumericalGroup.vue?vue&type=template&id=51548777&"
import script from "./IntervalNumericalGroup.vue?vue&type=script&lang=ts&"
export * from "./IntervalNumericalGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports